"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var TransactionRequest;
(function (TransactionRequest) {
    var Item = (function () {
        function Item() {
            this.id = undefined;
            this.quantity = undefined;
        }
        return Item;
    }());
    TransactionRequest.Item = Item;
    var ShippingInfo = (function () {
        function ShippingInfo() {
            this.address = undefined;
            this.number = undefined;
            this.apt = undefined;
            this.city = undefined;
            this.departament = undefined;
            this.zip = undefined;
        }
        return ShippingInfo;
    }());
    TransactionRequest.ShippingInfo = ShippingInfo;
    var BillingInfo = (function () {
        function BillingInfo() {
            this.rut = undefined;
            this.social = undefined;
            this.billingAddress = undefined;
        }
        return BillingInfo;
    }());
    TransactionRequest.BillingInfo = BillingInfo;
    var CustomerInfo = (function () {
        function CustomerInfo() {
            this.name = undefined;
            this.lastName = undefined;
            this.email = undefined;
            this.phone = undefined;
        }
        return CustomerInfo;
    }());
    TransactionRequest.CustomerInfo = CustomerInfo;
    var Create = (function () {
        function Create() {
            this.discountCode = undefined;
            this.items = undefined;
            this.customerInfo = undefined;
            this.shippingInfo = undefined;
            this.billingInfo = undefined;
        }
        return Create;
    }());
    TransactionRequest.Create = Create;
    var CheckoutBook = (function (_super) {
        __extends(CheckoutBook, _super);
        function CheckoutBook() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.isbn = undefined;
            _this.title = undefined;
            _this.author = undefined;
            _this.description = undefined;
            _this.price = undefined;
            _this.finalPrice = undefined;
            return _this;
        }
        return CheckoutBook;
    }(BaseModel_1["default"]));
    TransactionRequest.CheckoutBook = CheckoutBook;
    var CheckoutItem = (function () {
        function CheckoutItem(book, quantity, currencyId) {
            this.book = book;
            this.quantity = quantity;
            this.currencyId = currencyId;
        }
        return CheckoutItem;
    }());
    TransactionRequest.CheckoutItem = CheckoutItem;
    var Update = (function (_super) {
        __extends(Update, _super);
        function Update() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.delivered = undefined;
            return _this;
        }
        return Update;
    }(BaseModel_1["default"]));
    TransactionRequest.Update = Update;
})(TransactionRequest = exports.TransactionRequest || (exports.TransactionRequest = {}));
var TransactionResponse;
(function (TransactionResponse) {
    var Create = (function () {
        function Create(id, externalId, initUrl, outOfStock, notFound) {
            this.id = id;
            this.externalId = externalId;
            this.initUrl = initUrl;
            this.outOfStock = outOfStock;
            this.notFound = notFound;
        }
        return Create;
    }());
    TransactionResponse.Create = Create;
    var Transaction = (function (_super) {
        __extends(Transaction, _super);
        function Transaction() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.externalId = undefined;
            _this.itemsTransactionDetail = undefined;
            _this.amount = undefined;
            _this.delivered = undefined;
            _this.customerName = undefined;
            _this.customerLastName = undefined;
            _this.customerEmail = undefined;
            _this.customerPhone = undefined;
            _this.billingRut = undefined;
            _this.billingSocial = undefined;
            _this.billingAddress = undefined;
            _this.shippingAddress = undefined;
            _this.shippingNumber = undefined;
            _this.shippingApt = undefined;
            _this.shippingCity = undefined;
            _this.shippingDepartament = undefined;
            _this.shippingZip = undefined;
            _this.pay = undefined;
            _this.createdAt = undefined;
            _this.updatedAt = undefined;
            return _this;
        }
        return Transaction;
    }(BaseModel_1["default"]));
    TransactionResponse.Transaction = Transaction;
    var All = (function (_super) {
        __extends(All, _super);
        function All(objects, length, offset, pagination) {
            if (length === void 0) { length = 0; }
            if (offset === void 0) { offset = 0; }
            if (pagination === void 0) { pagination = 100; }
            var _this = _super.call(this) || this;
            _this.objects = undefined;
            _this.length = 0;
            _this.offset = 0;
            _this.pagination = 100;
            _this.objects = objects;
            _this.length = length;
            _this.offset = offset;
            _this.pagination = pagination;
            return _this;
        }
        return All;
    }(BaseModel_1["default"]));
    TransactionResponse.All = All;
})(TransactionResponse = exports.TransactionResponse || (exports.TransactionResponse = {}));



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/transaction.js
// module id = ../model/dist/models/transaction.js
// module chunks = main